import styles from "./styles.module.scss";

export const CarouselSliderBtn = ({
  handleClickBtn,
  variant = "next",
  Icon,
}) => {
  return (
    <div
      className={variant === "next" ? styles.nextIcon : styles.previousIcon}
      onClick={handleClickBtn}
    >
      <Icon />
    </div>
  );
};
